import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-prompt-dialog',
  templateUrl: './prompt-dialog.component.html',
  styleUrls: ['./prompt-dialog.component.css']
})
export class PromptDialogComponent implements OnInit {

  data:PromptOptions;
  inputValue:string = null;
  cancelable = true;
  showValidationMsg = false;

  constructor(public dialogRef: MatDialogRef<PromptDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public d: PromptOptions) {
      this.data = d;
      this.data.cancelMessage = d.cancelMessage ? d.cancelMessage : "Cancel";
      this.data.okMessage = d.okMessage ? d.okMessage : "OK"
      this.inputValue = d.defaultValue;
      this.cancelable = d.cancelable;
      if(!this.cancelable){
        this.dialogRef.disableClose = true;
      }
      if(this.data.valueRequiredMsg == null){
        this.data.valueRequiredMsg = "You can't leave this empty";
      }
      if(this.data.showInput == null){
        this.data.showInput = true;
      }
    }

  ngOnInit() {

  }

  closeDialog(){
    if(this.data.valueRequired){
      if(this.inputValue != null){
        if(this.inputValue.trim() != ""){
          this.dialogRef.close(this.inputValue);
        }else{
          this.showValidationMsg = true;
        }
      }else{
        this.showValidationMsg = true;
      }
    }else{
      this.dialogRef.close(this.inputValue);
    }
  }

}

export interface PromptOptions{
  msg:string
  title:string
  cancelMessage?:string
  okMessage?:string
  defaultValue?:string
  cancelable?:boolean
  valueRequired?:boolean
  valueRequiredMsg?:string
  showInput?:boolean
}
